/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* Homepage Best Seller (Sockeye) add-to-cart fix - 2026-09-20.
   The section's own handler (templates/index.json, section_os_bestseller)
   posts to /cart/add.js directly and never tells the theme's cart-store, so
   the item is added but the header count and the drawer keep showing the old
   cart and the click looks dead. This takes over that one form's submit in the
   capture phase, before the section's handler, and adds through cart-store -
   the same path as the product-card grid and the PDP - so the count and the
   drawer update. Remove once the section's own script is fixed.
   custom.js is included twice in layout/theme.liquid, hence the guard. */
(function () {
  if (window.__osBsbFix) return;
  window.__osBsbFix = true;

  function cartModule() {
    if (window.__ascCartReady && window.__ascCart) return Promise.resolve(window.__ascCart);
    return import('cart-store').then(function (m) { return m.default || null; }).catch(function () { return null; });
  }

  function openCartDrawer() {
    try {
      var drawer = document.querySelector('.modal--cart, .popup--cart-notification');
      if (!drawer) return;
      if (!drawer.shown && typeof drawer.open === 'function') { drawer.open(); }
      else if (drawer.interval) { drawer.interval.reset(); drawer.interval.start(); }
    } catch (_) {}
  }

  function showError(form, msg) {
    var old = form.querySelector('.os-bsb__error'); if (old) old.remove();
    var p = document.createElement('p'); p.className = 'os-bsb__error'; p.setAttribute('role', 'alert');
    p.style.cssText = 'margin:8px 0 0;color:#b3261e;font-size:13px;';
    p.textContent = msg || 'Could not add that. Please try again.';
    var btn = form.querySelector('.os-bsb__add'); if (btn && btn.parentNode) btn.parentNode.insertBefore(p, btn.nextSibling);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* getAttribute, not form.id: the form has an input named "id", which shadows it. */
    if (!form || !form.getAttribute || form.getAttribute('id') !== 'os-bsb-form') return;
    if (!window.fetch) return;              /* no fetch -> native POST to /cart */
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('.os-bsb__add'); var label = btn ? btn.textContent : '';
    if (btn && btn.disabled) return;
    var old = form.querySelector('.os-bsb__error'); if (old) old.remove();
    var idEl = form.querySelector('input[name="id"]');
    var planEl = form.querySelector('input[name="selling_plan"]:checked');
    var item = { id: Number(idEl && idEl.value), quantity: 1 };
    if (planEl && planEl.value) item.selling_plan = Number(planEl.value);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    cartModule().then(function (Cart) {
      if (Cart && typeof Cart.add === 'function') return Cart.add(item);
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || 'Could not add to cart'); return d; }); });
    }).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; }, 2600); }
      openCartDrawer();
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      showError(form, err && err.message);
    });
  }, true);
})();

/* Homepage mobile sticky bar vs the Best Seller - 2026-09-20.
   The sticky "Shop The Catch" bar (templates/index.json, section_liquid_6dCafV,
   mobile only) appears once the product grid scrolls past mid-screen - which is
   exactly when the Best Seller block comes up, so the fixed bar sat over its
   buy box and Add to Cart. This hides the bar while any part of the Best Seller
   form is on screen; it returns as soon as the shopper scrolls past. */
(function () {
  if (window.__osBsbStickyFix) return;
  window.__osBsbStickyFix = true;

  function init() {
    var form = document.getElementById('os-bsb-form');
    if (!form || !document.getElementById('asc-sticky-cta') || !('IntersectionObserver' in window)) return;
    var style = document.createElement('style');
    style.textContent = 'html.os-bsb-inview .asc-sticky-cta{display:none !important}';
    document.head.appendChild(style);
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('os-bsb-inview', entries[0].isIntersecting);
    }).observe(form);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
